import axios from "axios";

// Always use relative /api for production and reverse proxy
const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

export const api = axios.create({
  baseURL: BACKEND ? `${BACKEND}/api` : "/api",
  timeout: 15000,
});

export const TOKEN_KEY = "shchetka_admin_token";

export const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem(TOKEN_KEY);
    delete api.defaults.headers.common["Authorization"];
  }
};

// восстанавливаем токен при загрузке модуля
const stored = typeof window !== "undefined" ? localStorage.getItem(TOKEN_KEY) : null;
if (stored) api.defaults.headers.common["Authorization"] = `Bearer ${stored}`;

// глобальный interceptor: при 401 выкидываем на логин
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && typeof window !== "undefined") {
      const path = window.location.pathname;
      if (path.startsWith("/admin") && path !== "/admin/login") {
        setAuthToken(null);
        window.location.replace("/admin/login");
      }
    }
    return Promise.reject(err);
  }
);

export const formatApiError = (err, fallback = "Что-то пошло не так") => {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join("; ");
  if (d?.msg) return d.msg;
  return String(d);
};

export default api;
